export class CommandStatus {
    public static readonly Sent = 'Sent';
    public static readonly Expired = 'Expired';
    public static readonly Executed = 'Executed';
    public static readonly Rejected = 'Rejected';
    public static readonly Failed = 'Failed';
}